import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  BehaviorSubject,
  catchError,
  Observable,
  throwError,
  timeout,
  TimeoutError,
} from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);

  constructor(
    private authService: AuthService,
    private nzModalService: NzModalService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      // retry(5),
      // 1.5s 90000 timeout
      timeout(240000),
      catchError(error => {
        if (error.status === 403) {
          setTimeout(() => {
            this.handleError(error);
          }, 1000);
        }
        if (error.error instanceof ErrorEvent) {
          ///  client-side error
        } else if (error instanceof TimeoutError) {
          error = { ...error, error: {}, status: 408 };
          error.error.message = `Time over exceeded`;
          setTimeout(() => this.nzModalService.closeAll(), 2000);
        } else if (error.error instanceof ProgressEvent) {
          error = { ...error, error: error.error, status: 503 };
          error.error.message = `Server Unavailable`;
        }
        return throwError(() => error);
      })
    );
  }

  handleError(error: any): void {
    if (error?.error?.code === '4031') {
      // this.menuService.onSubInscriptionFailed(true);
    } else if (error?.error?.code === '4033') {
      console.log('show alert message');
      // this.utilsService.showError('Login Unavailable', 'Your account is currently inactive. Please contact us for assistance.');
      // this.handle4033Error();
    } else {
      // this.showErrorMessageModal(error);
    }
  }
}
